import { Icon, Spinner, Stack, Text } from '@chakra-ui/react';
import { MailIcon } from '@heroicons/react/outline';
import { useTranslations } from 'use-intl';

import { FundraisingType, noop } from '@blockpulse3/data/shared';
import { FundraisingStatus } from '@blockpulse3/graphql/hooks';
import { ErrorQueryCard } from '@blockpulse3/ui/commons';

import { FundraisingTable } from '../FundraisingTable';
import { useGetFundraisings } from '../hook/useGetFundraisings';

type Props = {
  onClick?: (id: string, fundraisingType: FundraisingType, fundraisingCompanyId?: string) => void;
};

/**
 * FundraisingTablePassed.
 * Query and display PASSED Fundraisings.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function FundraisingTablePassed({ onClick = noop }: Props): JSX.Element {
  const i18nFundraisingTableEmpty = useTranslations('FundraisingTableEmpty');

  const { fundraisings, fundraisingsLoading, fundraisingsError } = useGetFundraisings(
    FundraisingStatus.FINALIZED,
  );

  if (fundraisingsLoading) {
    return (
      <Stack h="170px" layerStyle="emptyState">
        <Spinner />
      </Stack>
    );
  }

  if (fundraisingsError) {
    return <ErrorQueryCard h="170px" />;
  }

  const isEmpty = fundraisings.length === 0;

  const handleTableClick = (
    id: string,
    fundraisingType: FundraisingType,
    fundraisingStatus?: string,
    fundraisingCompanyId?: string,
  ): void => {
    onClick(id, fundraisingType, fundraisingCompanyId);
  };

  return isEmpty ? (
    <Stack layerStyle="emptyState">
      <Icon as={MailIcon} boxSize="40px" color="gray.500" />
      <Text>{i18nFundraisingTableEmpty('NoFundraisingPast')}</Text>
    </Stack>
  ) : (
    <FundraisingTable values={fundraisings} onClick={handleTableClick} />
  );
}
